var _excluded = ["role", "as", "children", "stretch"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled, { css } from 'styled-components';
import { applyDisabled } from '../../mixins';
import { StyledTabItem } from './TabItem';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('Tabs/Tabs');
export var StyledTabs = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma__sc-z15rbr-0"
})(["position:relative;display:inline-flex;align-items:center;box-sizing:border-box;flex-wrap:nowrap;justify-content:stretch;padding:0;margin:0;width:max-content;list-style-type:none;user-select:none;-webkit-tap-highlight-color:rgba(0,0,0,0);", " gap:inherit;"], function (_ref) {
  var _ref$stretch = _ref.stretch,
      stretch = _ref$stretch === void 0 ? false : _ref$stretch;
  return !stretch && css(["margin:0 var(--tabs-margin);"]);
});
export var StyledWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma__sc-z15rbr-1"
})(["overflow-x:auto;margin-left:calc(var(--tab-focus-border-size) * -1);margin-top:calc(var(--tab-focus-border-size) * -2);padding:var(--tab-focus-border-size);transform:translateY(var(--tab-focus-border-size));&::-webkit-scrollbar{display:none;}", "{", "}", " ", " ", "{", "}gap:0.125rem;"], StyledTabs, applyDisabled, function (_ref2) {
  var stretch = _ref2.stretch;
  return stretch && css(["width:100%;", "{width:100%;}", "{flex:1 1 calc((100% / 4) - 0.125rem);}"], StyledTabs, StyledTabItem);
}, function (_ref3) {
  var _ref3$stretch = _ref3.stretch,
      stretch = _ref3$stretch === void 0 ? false : _ref3$stretch;
  return !stretch && css(["margin-left:calc(var(--tabs-margin) * -1 + var(--tab-focus-border-size) * -1);margin-right:calc(var(--tabs-margin) * -1);"]);
}, StyledTabItem, function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled && css(["cursor:not-allowed;"]);
});
/**
 * Контейнер вкладок.
 */

export var Tabs = /*#__PURE__*/React.forwardRef(function (_ref5, ref) {
  var _ref5$role = _ref5.role,
      role = _ref5$role === void 0 ? 'tablist' : _ref5$role,
      as = _ref5.as,
      children = _ref5.children,
      stretch = _ref5.stretch,
      rest = _objectWithoutProperties(_ref5, _excluded);

  return /*#__PURE__*/React.createElement(StyledWrapper, _extends({
    stretch: stretch
  }, rest), /*#__PURE__*/React.createElement(StyledTabs, {
    as: as,
    ref: ref,
    role: role,
    stretch: stretch
  }, children));
});